import {AccountService} from '../../../services/AccountService';
import {groups} from '../../../services/arsweb/RoutingPaths';
import {SearchableItemService} from "../../../services/SearchableItemService";
import {DetailController} from "../../../controller/DetailController";
import {EDITROUTE, DELETEROUTE} from "../../../routes/accountGroups.route";
import {keyLanguage} from "fides-angularjs-components/src/fts-services/fts-user-service";
import {ACCOUNTGROUPS_TAB} from "../../../components/tables/administration/groups/groupAccountsTable.directive";

/** @ngInject */
export class GroupDetailController extends DetailController {

    constructor($scope, userService, arsMainDependencies) {
        super($scope, userService, arsMainDependencies, groups, new AccountService(userService));

        this.userService = userService;
        this.createOrUpdateFunction = this.state.params.createOrUpdateFunction;
        if (this.id && this.state.params.editMode === 'view') {
            this.reactTabs = {tabs: [{label: this.translate.instant('RELATED_ACCOUNTS'), value: ACCOUNTGROUPS_TAB}]};
            this.detailviewDataPromise.then(() => {
                this.reactTitleParams = {
                    crumbProps: {crumbs: [{
                        label: this.translate.instant('ACCOUNT_GROUPS'), stateAction: (event)=> this.cancel(event)},
                        {label: this.translate.instant('DETAILS')}]},
                    headline:  this.element.groupName,
                    subline: this.translate.instant('ACC_GROUPNAME'),
                    infoTitle: this.translate.instant('LAST_UPDATE') + " " +
                        userService.filterFormatter('fsDateTime')(this.element.lastUpdate),
                    editAction: ()=> this.state.go(EDITROUTE, { id: this.id}),
                    functionProps : {
                        functions: [{
                            label: this.translate.instant('DELETE_ACCOUNT_GROUP'),
                            handleAction: ()=> this.deleteElement(DELETEROUTE,'groupName')
                        }]
                    },
                    lng: this.store.get(keyLanguage) };
            });
        } else {
            this.reactTitleParams = {
                clearAction: () => this.cancel(),
                functionProps : {},
                lng: this.store.get(keyLanguage) };
        }
    }

    save() {
        if(this.$scope.detailForm.$valid) {
            this.isProcessing = true;
            this.$scope.$broadcast('loadSelection');
            if(this.selectedItems) {
                this.element.membersCount = this.element.userAccounts.length;
            } else if(!this.isAllSelected) {
                this.element.membersCount = 0;
            }
            return super[this.createOrUpdateFunction]().then(() =>
                new SearchableItemService(this.userService).getSearchableItems(this.$scope,true))
                .then(()=> this.cancel());
        } else {
            this.infoPop('MISSING_MANDATORY');
        }
    }
}
